export type ExportFormat = 'XLSX' | 'CSV'
export type ExportDestination = 'LOCAL' | 'SFTP' | 'SHAREPOINT'

export const DESTINATION_LABELS: Record<ExportDestination, string> = {
  LOCAL: 'A folder on the server',
  SFTP: 'An SFTP server',
  SHAREPOINT: 'SharePoint — not implemented',
}

export const DESTINATION_NOTES: Record<ExportDestination, string> = {
  LOCAL: 'Usually a mounted share. The path must be inside the roots the server allows.',
  SFTP: 'The host key is pinned and required; without it the run fails rather than trusting whoever answers.',
  SHAREPOINT: 'Declared so the shape is fixed, but nothing delivers yet. Choosing it fails the run with that message rather than silently sending nothing.',
}

export interface ReportOption {
  key: string
  label: string
}

export interface ExportConfigView {
  id: string
  legalEntityId: string | null
  name: string
  reportKey: string
  format: ExportFormat
  destination: ExportDestination
  targetPath: string
  sftpHost: string | null
  sftpPort: number | null
  sftpUsername: string | null
  /** Whether a password is stored. It is never sent back to the screen. */
  sftpPasswordSet: boolean
  sftpHostKey: string | null
  cron: string
  active: boolean
  lastRunAt: string | null
  lastRunStatus: string | null
  lastRunMessage: string | null
}

export interface RunView {
  status: string
  message: string
  rowCount: number
  bytes: number
}

/**
 * Quartz cron, which is not Unix cron.
 *
 * Six or seven fields with seconds first, and either day-of-month or day-of-week must be `?`.
 * Written out on the screen because everyone's first attempt is a five-field Unix expression
 * and the error alone does not explain why.
 */
export const CRON_PRESETS: { label: string; value: string }[] = [
  { label: 'Every day at 02:30', value: '0 30 2 * * ?' },
  { label: 'Every Monday at 06:00', value: '0 0 6 ? * MON' },
  { label: 'The 1st of each month at 01:00', value: '0 0 1 1 * ?' },
  { label: 'Every hour, on the hour', value: '0 0 * * * ?' },
]
